import { render, staticRenderFns } from "./attachCustomer.vue?vue&type=template&id=7c097d97&scoped=true&"
import script from "./attachCustomer.vue?vue&type=script&lang=js&"
export * from "./attachCustomer.vue?vue&type=script&lang=js&"
import style0 from "./attachCustomer.vue?vue&type=style&index=0&id=7c097d97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c097d97",
  null
  
)

export default component.exports